import moment from "moment";
import React, { useState } from "react";

const ProfitlossCard = ({ item, isExpanded, onToggle }) => {
    const [localExpanded, setLocalExpanded] = useState(false);

    const expanded = isExpanded !== undefined ? isExpanded : localExpanded;
    const handleToggle = () => {
        if (onToggle) {
            onToggle();
        } else {
            setLocalExpanded(prev => !prev);
        }
    };

    return (
        <div style={styles.wrapper}>

            {/* =========================
          TOP / ALWAYS VISIBLE PART
      ========================== */}
            <div style={styles.card}>

                {/* Match title */}
                <div style={styles.matchHeader}>
                    <div style={styles.matchName}>
                        <span style={styles.sport}>{item.sportType}</span>
                        <span> ▸ </span>
                        <strong>{item.eventName}</strong>
                        <span> ▸</span>
                    </div>

                    <div style={styles.marketName}>
                        {item.marketName}
                    </div>
                </div>

                {/* Dates / Profit */}
                <div style={styles.infoRow}>

                    <div style={{ ...styles.infoColumn, borderRight: "1px solid #c7d4da" }}>
                        <div style={styles.label}>Start Time</div>

                        <div style={styles.value}>
                            {moment(item.startTime).format("YYYY-MM-DD")}
                        </div>

                        <div style={styles.value}>
                            {moment(item.startTime).format("HH:mm:ss")}
                        </div>
                    </div>

                    <div style={{ ...styles.infoColumn, borderRight: "1px solid #c7d4da" }}>
                        <div style={styles.label}>Settled Date</div>

                        <div style={styles.value}>
                            {moment(item.settledDate).format("YYYY-MM-DD")}
                        </div>

                        <div style={styles.value}>
                            {moment(item.settledDate).format("HH:mm:ss")}
                        </div>
                    </div>

                    <div style={styles.infoColumn}>
                        <div style={styles.label}>
                            Profit/Loss (USD)
                        </div>

                        <div style={{ ...styles.profit, color: item?.profitLoss >= 0 ? "#00a000" : "#ff0000" }}>
                            {item?.profitLoss.toFixed(2)}
                        </div>
                    </div>

                </div>

                {/* =========================
            EXPANDED CONTENT
        ========================== */}

                {expanded && (
                    <>
                        {item.bets?.length > 0 && item.bets.map((bet) => (
                            <>
                                {/* Bet placed header */}
                                <div style={{ ...styles.betPlaced, background: "#9cb1bd" }}>
                                    <strong style={{ fontSize: "12.48px", fontWeight: 700 }}>{bet.betId}</strong>

                                    <span style={{ fontSize: "12.48px", fontWeight: 400 }}>
                                        Bet Placed {moment(bet.betPlaced).format("YYYY-MM-DD HH:mm:ss")}
                                    </span>
                                </div>

                                {/* Back / Middlesex */}
                                <div style={styles.backRow}>
                                    <span style={styles.backButton}>
                                        {bet.betSide}
                                    </span>

                                    <strong>{bet.selection}</strong>
                                </div>
                                {/* Odds / Stake / Profit */}
                                <div style={{ ...styles.marketRow, borderTop: "1px solid #aebfc8" }}>

                                    <div style={{ ...styles.marketColumn, borderRight: "1px solid #aebfc8" }}>
                                        <div style={styles.label}>Odds</div>
                                        <strong style={{ fontSize: "14.56px" }}>{bet.oddsUp}</strong>
                                    </div>

                                    <div style={{ ...styles.marketColumn, borderRight: "1px solid #aebfc8" }}>
                                        <div style={styles.label}>Stake (USD)</div>
                                        <strong style={{ fontSize: "14.56px" }}>{bet.stake.toFixed(2)}</strong>
                                    </div>

                                    <div style={styles.marketColumn}>
                                        <div style={styles.label}>
                                            Profit & Loss (USD)
                                        </div>

                                        <strong style={{ fontSize: "14.56px", color: bet.profitLoss >= 0 ? "#00a000" : "#ff0000" }}>
                                            {bet.profitLoss.toFixed(2)}
                                        </strong>
                                    </div>

                                </div>

                                {/* Subtotals */}
                                <div style={styles.subtotal}>

                                    <div style={{ width: "100%", display: "flex" }}>
                                        <div style={{ width: "35%" }}>Back Subtotal</div>
                                        <div style={{ width: "65%" }}>{bet.backSubtotal.toFixed(2)}</div>
                                    </div>

                                    <div style={{ width: "100%", display: "flex" }}>
                                        <div style={{ width: "35%" }}>Lay Subtotal</div>
                                        <div style={{ width: "65%" }}>{bet.laySubtotal.toFixed(2)}</div>
                                    </div>

                                    <div style={{ width: "100%", display: "flex" }}>
                                        <div style={{ width: "35%" }}>Market subtotal</div>
                                        <div style={{ width: "65%" }}>{bet.profitLoss.toFixed(2)}</div>
                                    </div>

                                    <div style={{ width: "100%", display: "flex" }}>
                                        <div style={{ width: "35%" }}>Commission</div>
                                        <div style={{ width: "65%" }}>({bet.commission.toFixed(2)})</div>
                                    </div>

                                </div>

                                {/* Net Market Total */}
                                <div style={styles.netTotal}>
                                    <span style={{ width: "35%" }}>Net Market Total</span>

                                    <strong style={{ fontSize: "12.48px", color: bet.profitLoss >= 0 ? "#00a000" : "#ff0000", width: "65%" }}>
                                        {bet.profitLoss.toFixed(2)}
                                    </strong>
                                </div>
                            </>
                        ))}
                    </>
                )}

            </div>

            {/* =========================
          DOWN ARROW
      ========================== */}
            <div style={{ width: "100%", height: "7.2px", borderBottomRightRadius: "0.5rem", borderBottomLeftRadius: "0.5rem", background: "#d4e0e5" }} />
            <button
                type="button"
                onClick={handleToggle}
                style={styles.arrowButton}
                aria-label={expanded ? "Collapse" : "Expand"}
            >
                <span
                    style={{
                        ...styles.arrow,
                        transform: expanded
                            ? "rotate(225deg)"
                            : "rotate(45deg)",
                    }}
                />
            </button>

        </div>
    );
};


const styles = {

    wrapper: {
        width: "100%",
        margin: "0 auto 8px",
        fontSize: "12.48px",
    },

    card: {
        background: "#e8f0f4",
        borderTopLeftRadius: "0.5rem",
        borderTopRightRadius: "0.5rem",
        overflow: "hidden",
    },

    /* Match header */
    matchHeader: {
        background: "#d5e2e8",
        textAlign: "center",
        padding: "0.5rem 1rem",
        lineHeight: "17px",
    },

    matchName: {
        fontSize: "13.52px",
        color: "#111",
    },

    sport: {
        fontWeight: "400",
    },

    marketName: {
        fontSize: "13.52px",
        color: "#111",
    },

    /* Start / Settled / Profit */
    infoRow: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        background: "#f5f8fa",
    },

    infoColumn: {
        minWidth: 0,
        padding: "6px 7px 8px",
        // borderRight: "1px solid #c7d4da",
    },

    label: {
        fontSize: "10.4px",
        color: "#111",
        marginBottom: "2px",
    },

    value: {
        fontSize: "14.56px",
        fontWeight: "700",
        lineHeight: "1.2",
        whiteSpace: "nowrap",
    },

    profit: {
        // color: "#008f00",
        fontWeight: "700",
        fontSize: "14.56px"
    },

    /* Bet placed */
    betPlaced: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "5px",
        background: "#e2eaef",
        padding: "6px 7px",
        fontSize: "10.4px",
        whiteSpace: "nowrap",
    },

    /* Back + Middlesex */
    backRow: {
        display: "flex",
        alignItems: "center",
        gap: "7px",
        background: "#dce8ee",
        padding: "7px",
        fontSize: "13px",
    },

    backButton: {
        background: "#a9d7ef",
        borderRadius: "15px",
        padding: "4px 13px",
        fontWeight: "700",
        textTransform: "lowercase",
    },

    /* Odds / Stake / P&L */
    marketRow: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr",
        // background: "#e6eef2",e
    },

    marketColumn: {
        padding: "7px",
        // borderRight: "1px solid #aebfc8",
        minWidth: 0,
    },

    /* Subtotal */
    subtotal: {
        padding: "7px",
        background: "#e6eef2",
        borderTop: "1px solid #aebfc8",
        width: '100%'
    },

    subtotalRow: {
        display: "flex",
        justifyContent: "space-between",
    },

    /* Net total */
    netTotal: {
        display: "flex",
        padding: "8px 7px",
        borderTop: "1px solid #aebfc8",
        background: "#dce7ec",
    },

    /* Arrow container */
    arrowButton: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "94px",
        height: "19px",
        margin: "-1px auto 0",
        padding: 0,
        border: "none",
        background: "#d5e2e8",
        borderRadius: "0 0 8px 8px",
        cursor: "pointer",
    },

    arrow: {
        width: "9px",
        height: "9px",
        borderRight: "3px solid #111",
        borderBottom: "3px solid #111",
        transition: "transform 0.2s ease",
        marginTop: "-4px",
    },
};

export default ProfitlossCard;